import { createAsyncThunk } from '@reduxjs/toolkit';
import api, { handleApiError } from 'state/api';

export const getListingsApi = createAsyncThunk(
  'listings/getListingsApi',
  async (
    {
      page = 1,
      limit = 25,
      search = '',
      searchField = 'all',
      status = '',
      priceMin,
      priceMax,
      quantityMin,
      quantityMax,
      marketplace = '',
      store = '',
      supplier = '',
      sortBy = 'dateCreated+',
    },
    { rejectWithValue },
  ) => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        searchField,
        sortBy,
      });

      if (search) params.append('search', search);
      if (status) params.append('status', status);
      if (priceMin !== undefined) params.append('priceMin', priceMin.toString());
      if (priceMax !== undefined) params.append('priceMax', priceMax.toString());
      if (quantityMin !== undefined) params.append('quantityMin', quantityMin.toString());
      if (quantityMax !== undefined) params.append('quantityMax', quantityMax.toString());
      if (marketplace) params.append('marketplace', marketplace);
      if (store) params.append('store', store);
      if (supplier) params.append('supplier', supplier);

      const response = await api.get(`listings?${params.toString()}`);
      return response.data.success ? response.data.data : response.data;
    } catch (error) {
      return handleApiError('getListingsApi', error, rejectWithValue);
    }
  },
);

export const getListingApi = createAsyncThunk(
  'listings/getListingById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`listings/${id}`);
      return response.data.success ? response.data.data : response.data;
    } catch (error) {
      return handleApiError('getListingByIdApi', error, rejectWithValue);
    }
  },
);

export const deleteListingApi = createAsyncThunk(
  'listings/deleteListing',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`listings/${id}`);
      return response.data;
    } catch (error) {
      return handleApiError('deleteListingApi', error, rejectWithValue);
    }
  },
);

export const updateListingApi = createAsyncThunk(
  'listings/updateListing',
  async ({ id, updateData }, { rejectWithValue }) => {
    try {
      const response = await api.put(`listings/${id}`, updateData);
      return response.data;
    } catch (error) {
      return handleApiError('updateListingApi', error, rejectWithValue);
    }
  },
);

export const deleteListingsByFilterApi = createAsyncThunk(
  'listings/deleteListingsByFilter',
  async ({ storeId }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      if (storeId) params.append('storeId', storeId);

      const response = await api.delete(`listings?${params.toString()}`);
      return response.data;
    } catch (error) {
      return handleApiError('deleteListingsByFilterApi', error, rejectWithValue);
    }
  },
);
